// Usar variable de entorno o fallback a localhost para desarrollo
const SERVER_IP = process.env.REACT_APP_SERVER_IP || "localhost:3977";
const PROTOCOL = process.env.REACT_APP_PROTOCOL || "http";

export const ENV = {
  BASE_PATH: `${PROTOCOL}://${SERVER_IP}`,
  BASE_API: `${PROTOCOL}://${SERVER_IP}/api/v1`,
  API_ROUTES: {
    REGISTER: "auth/register",
    LOGIN: "auth/login",
    REFRESH_ACCESS_TOKEN: "auth/refresh_access_token",
    SWITCH_SITE: "auth/switch-site",
    VERIFY_2FA_EMAIL_CODE: "auth/2fa/verify-email-code",
    RESEND_2FA_CODE: "auth/2fa/resend-code",
    USER_ME: "user/me",
    USER: "user",
    USERS: "users",
    MENU: "menu",
    COURSE: "course",
    NEWSLETTER: "newsletter",
    POST: "post",
    COMPANY_ME:"company/me"
  },
  JWT: {
    ACCESS: "access",
    REFRESH: "refresh",
  },
};

export const MODULES = [
  "dashboard",
  "configure",
  "permissions",
  "reports",
  "roles",
  "users",
  "sites",
  "companies",


  // "siteform",
  // "productionform",
  // "energyform",
  // "effluentform",
  // "waterform",
  // "wasteform",
  // "kpisform",
  "data",
  "sources"
];

export const FORMS=[
  "social",
  "production",
  "energy",
  "effluent",
  "water",
  "waste",
  // "kpis",
  // "dangerous",
  "fuel"
];


export const ACTIONS = [
  "delete",
  "create",
  "edit",
  "menu",
  "view",
]

export const PERIODS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
]

//PARA DASHBOARD Y CALCULOS
export const effluentIndicators = {
  industrial_effluent_kpis: ["total_industrial_effluents","total_industrial_effluents"],
  domestic_effluent_kpis: "total_domestic_effluents",
  total_effluents_kpis: "total_industrial_effluents",
  effluent_recycled_kpis: "total_domestic_effluents",
  sludge_kpis: "total_domestic_effluents",
  sludge_disposition_cost_kpis: "sludge_mud_sent_for_disposal_landfill",
  domestic_effluent_treatment_cost_kpis: "total_domestic_effluents",
  industrial_effluent_treatment_cost_kpis: "total_domestic_effluents",
  total_effluent_treatment_cost_kpis: "total_domestic_effluents",
};

//MONEDAS

export const coins=[
  "Peso mexicano (MXN)",
  "Dólar beliceño (BZD)",
  "Colón costarricense (CRC)",
  "Dólar estadounidense (USD)",
  "Bitcoin (BTC)",
  "Quetzal (GTQ)",
  "Lempira (HNL)",
  "Córdoba nicaragüense (NIO)",
  "Balboa (PAB)",
  "Peso cubano (CUP)",
  "Peso convertible cubano (CUC) (en desuso)",
  "Peso dominicano (DOP)",
  "Gourde (HTG)",
  "Dólar canadiense (CAD)",
  "Peso argentino (ARS)",
  "Boliviano (BOB)",
  "Real brasileño (BRL)",
  "Peso chileno (CLP)",
  "Peso colombiano (COP)",
  "Dólar guyanés (GYD)",
  "Guaraní (PYG)",
  "Sol (PEN)",
  "Dólar surinamés (SRD)",
  "Peso uruguayo (UYU)",
  "Bolívar digital (VES)",
]

export const units=[{ key: 1, value: "kWh", name: "kWh" },{ key: 2, value: "MWh", name: "MWh" }, { key: 3, value: "mmbtu", name: "mmBTU" },
  { key: 4, value: "btu", name: "BTU" }, { key: 5, value: "J", name: "Joule" }
];

export const units_1=[{ key: 1, value: "L", name: "Litros (L)" },{ key: 2, value: "m3", name: "m³" }, { key: 3, value: "GJ", name: "GJ" },
  { key: 4, value: "kWh", name: "kWh" }, { key: 5, value: "mmbtu", name: "mmBTU" },{ key: 6, value: "btu", name: "BTU" }, { key: 7, value: "J", name: "Joule" }
];

export const units_2=[{ key: 1, value: "kWh", name: "kWh" },{ key: 2, value: "MJ", name: "MJ" }, { key: 3, value: "mmbtu", name: "mmBTU" },
  { key: 4, value: "btu", name: "BTU" }, { key: 5, value: "J", name: "Joule" },{ key: 6, value: "L", name: "Litros (L)" },{ key: 7, value: "US gallons", name: "US gallons" },
  { key: 8, value: "m3", name: "m³" }
];

export const units_3=[{ key: 1, value: "kWh", name: "kWh" },{ key: 2, value: "MJ", name: "MJ" }, { key: 3, value: "mmbtu", name: "mmBTU" },
  { key: 4, value: "btu", name: "BTU" }, { key: 5, value: "J", name: "Joule" }
]

export const units_4=[{ key: 1, value: "m3", name: "m³" },{ key: 2, value: "GJ", name: "GJ" }, { key: 3, value: "kWh", name: "kWh" },
  { key: 4, value: "g", name: "g" }, { key: 5, value: "kg", name: "kg" }, { key: 6, value: "lb", name: "lb" }, { key: 7, value: "oz", name: "oz" },
  { key: 8, value: "ton_metrica", name: "ton (métrica)" }, { key: 9, value: "ton_corta", name: "ton (corta)" }, { key: 10, value: "MJ", name: "MJ" }, { key: 11, value: "mmbtu", name: "mmBTU" },
  { key: 12, value: "btu", name: "BTU" }, { key: 13, value: "J", name: "Joule" },{ key: 14, value: "L", name: "Litros (L)" }, { key: 15, value: "us_gallons", name: "US gallons" }
]

export const units_5=[{ key: 1, value: "ton_metrica", name: "Toneladas métricas (t)" },{ key: 2, value: "GJ", name: "GJ" }, { key: 3, value: "kWh", name: "kWh" },
  { key: 4, value: "g", name: "g" }, { key: 5, value: "kg", name: "kg" }, { key: 6, value: "lb", name: "lb" }, { key: 7, value: "oz", name: "oz" },
  { key: 8, value: "ton_metrica", name: "ton (métrica)" }, { key: 9, value: "ton_corta", name: "ton (corta)" }, { key: 10, value: "MJ", name: "MJ" }, { key: 11, value: "mmbtu", name: "mmBTU" },
  { key: 12, value: "btu", name: "BTU" }, { key: 13, value: "J", name: "Joule" }
]

export const units_6=[{ key: 1, value: "ton_metrica", name: "Toneladas métricas (t)" },{ key: 2, value: "GJ", name: "GJ" }, { key: 3, value: "kWh", name: "kWh" }
]

export const units_7=[{ key: 1, value: "ton_metrica", name: "Toneladas métricas (t)" },{ key: 2, value: "GJ", name: "GJ" }, { key: 3, value: "kwh_termico", name: "kWh térmicos" },
  { key: 4, value: "g", name: "g" }, { key: 5, value: "kg", name: "kg" }, { key: 6, value: "lb", name: "lb" }, { key: 7, value: "oz", name: "oz" },
  { key: 8, value: "ton_metrica", name: "ton (métrica)" }, { key: 9, value: "ton_corta", name: "ton (corta)" }, { key: 10, value: "MJ", name: "MJ" }, { key: 11, value: "mmbtu", name: "mmBTU" },
  { key: 12, value: "btu", name: "BTU" }, { key: 13, value: "J", name: "Joule" }
]

export const units_8=[{ key: 1, value: "L", name: "Litros (L)" },{ key: 2, value: "m3", name: "m³" }, { key: 3, value: "galon", name: "galon" },
]

export const units_9=[{ key: 1, value: "L", name: "Litros (L)" },{ key: 2, value: "m3", name: "m³" }, { key: 3, value: "galon", name: "galon" },
  { key: 4, value: "g", name: "g" },{ key: 5, value: "kg", name: "kg" }
]
export const units_10=[{ key: 1, value: "g", name: "g" },{ key: 2, value: "kg", name: "kg" }, { key: 3, value: "ton", name: "ton" },{ key: 4, value: "L", name: "Litros (L)" },
  { key: 5, value: "m3", name: "m³" },
]

export const units_11=[{ key: 1, value: "ppm", name: "ppm" },{ key: 2, value: "mg/m3", name: "mg/m³" }, { key: 3, value: "µg/m3", name: "µg/m³" },
  { key: 4, value: "ng/m3", name: "ng/m³" }, { key: 5, value: "g/s", name: "g/s" }, { key: 6, value: "kg/h", name: "kg/h" }, { key: 7, value: "m3/h", name: "m³/h" },
  { key: 8, value: "l/min", name: "L/min" }, { key: 9, value: "m3/s", name: "m³/s" }, { key: 10, value: "% vol", name: "% vol" }, { key: 11, value: "mg", name: "mg" },
  { key: 12, value: "m3", name: "m³" }, { key: 13, value: "µg", name: "µg" }, { key: 14, value: "ng", name: "ng" }, { key: 15, value: "g", name: "g" },
  { key: 16, value: "s", name: "s" }, { key: 17, value: "kg", name: "kg" }, { key: 18, value: "m3", name: "m³" }, { key: 19, value: "L", name: "Litros (L)" }
]

export const pollutants=[{ key: 1, value: "Material particulado", name: "Material particulado" },{ key: 2, value: "Óxidos de nitrógeno (NOx)", name: "Óxidos de nitrógeno (NOx)" }, { key: 3, value: "Óxidos de azufre (SOx)", name: "Óxidos de azufre (SOx)" },
  { key: 4, value: "Monóxido de carbono (CO)", name: "Monóxido de carbono (CO)" }, { key: 5, value: "Compuestos orgánicos volátiles (COV) o carbono orgánico total (COT)", name: "Compuestos orgánicos volátiles (COV) o carbono orgánico total (COT)" }, { key: 6, value: "Contaminantes atmosféricos tóxicos o peligrosos (HAP/TAP)", name: "Contaminantes atmosféricos tóxicos o peligrosos (HAP/TAP)" }, { key: 7, value: "Materia particulada", name: "Materia particulada" },
  { key: 8, value: "Óxidos de nitrógeno (NOx)", name: "Óxidos de nitrógeno (NOx)" }, { key: 9, value: "Óxidos de azufre (SOx)", name: "Óxidos de azufre (SOx)" }
]

export const coins_units = coins.map((i, index) => {
  // Buscar abreviatura entre paréntesis, ej. "Peso argentino (ARS)" → "ARS"
  const match = i.match(/\(([A-Z]{2,5})\)/);
  const short = match ? match[1] : i; // Si no tiene paréntesis, usa el nombre completo

  return {
    key: index,
    value: i,     // Valor completo
    name: i,      // Nombre para mostrar en menús o tooltips
    short,        // Abreviatura (ej. "ARS")
  };
});
export const units_12=[{ key: 1, value: "Un", name: "Un." }]

export const higgs_units=["Unidades", "Piezas", "Pares", "Kg", "Tn", "Yardas", "Metros lineales"].map((i,index)=>{return{key: index, value: i, name: i}});

// Mapa canónico de todas las unidades definidas en el sistema
const _canonicalUnits = [
  ...units, ...units_1, ...units_2, ...units_3, ...units_4,
  ...units_5, ...units_6, ...units_7, ...units_8, ...units_9,
  ...units_10, ...units_11, ...units_12,
].map(u => u.value).filter((v, i, arr) => arr.indexOf(v) === i);

// Convierte un código de unidad guardado a su forma canónica.
// Ejemplo: "l" → "L", "kwh" → "kWh". Si no hay match devuelve el valor original.
export const normalizeUnit = (unit) => {
  if (!unit) return unit;
  const trimmed = unit.trim();
  return _canonicalUnits.find(v => v.toLowerCase() === trimmed.toLowerCase()) || trimmed;
};

